import angular from 'angular'

var angularMaterialize = require('angular-materialize')

export var $candidatoPublicMod = angular.module('candidatoPublic', ['candidato', angularMaterialize])
